import { getCountries, getStates } from 'country-state-picker'
import { useMemo } from 'react'
import { sortCountriesByName } from '../utils'

export type Option = {
  label: string
  value: string
  code?: string
}

export type Country = {
  name: string
  code: string
  dial_code?: string
}

const mapStatesToOptions = (states: string[]): Option[] => states?.map(s => ({ label: s, value: s }))
export const mapCountriesToOptions = (countries: Country[]): Option[] =>
  countries?.map(({ name, code }) => ({
    label: name,
    value: name,
    code
  }))
export const useCountryStateOptions = (country?: string) => {
  const countries = getCountries()

  const filterCountries = countries.filter((item: any) => item.name !== 'NULL')

  const sortedCountries = useMemo(() => {
    return mapCountriesToOptions(sortCountriesByName(filterCountries))
  }, [filterCountries])

  const states = useMemo(() => {
    if (!country) return []

    const selected = sortedCountries.find(c => c.label === country)
    if (!selected) return []

    const countryStates = getStates(selected.code as string) // from library
    return mapStatesToOptions(countryStates)
  }, [country, sortedCountries])

  return { countries: sortedCountries, states }
}
